import React, { useState } from 'react';
import AddToSelfCart from '../AddToSelfCart/AddToSelfCart'; 
import './MedicineSearchModal.css';

const MedicineSearchModal = ({ vendorsData, onClose, onAddToCart }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [cart] = useState([]);
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredMedicines = vendorsData.flatMap(vendor => vendor.availableMedicines)
    .filter(medicine => medicine.name.toLowerCase().includes(searchQuery.toLowerCase()));

  const handleAddToCartClick = (medicine) => {
    setSelectedMedicine(medicine);
    setShowAddToCartModal(true);
  };

  const handleCloseModal = () => {
    setShowAddToCartModal(false);
    setSelectedMedicine(null);
  };

  return (
    <div className="medicine-search-modal-vendors">
      <div className="modal-content-medicinename">
        <div className="modal-header">
          <h2>Search Medicines</h2>
          <button className="close-btn-vendors" onClick={onClose}>✖</button>
        </div>

        <div className="search-bar-vendors">
          <input 
            type="text" 
            placeholder="Search by medicine name..." 
            value={searchQuery}
            onChange={handleSearch}
            className="medicine-search-input-vendors"
          />
        </div>

        <table className="medicine-table-vendors">
          <thead>
            <tr>
              <th>Name</th>
              <th>Company</th>
              <th>Expiry Date</th>
              <th>Strength</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredMedicines.map((medicine, index) => (
              <tr key={index}>
                <td>{medicine.name}</td>
                <td>{medicine.company}</td>
                <td>{medicine.expiryDate}</td>
                <td>{medicine.strength}</td>
                <td>{medicine.price}</td>
                <td>
                  <button 
                    onClick={() => handleAddToCartClick(medicine)} 
                    className="add-to-cart-btn-searching"
                  >
                    Add to Cart
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="cart-summary-vendors">
          <h3>Cart ({cart.length} items)</h3>
        </div>
      </div>

      {showAddToCartModal && (
        <AddToSelfCart
          medicine={selectedMedicine}
          onClose={handleCloseModal}
          onAddToCart={onAddToCart}
        />
      )}
    </div>
  );
};

export default MedicineSearchModal;
